import * as React from 'react';
import { LanguageContext } from './LanguageContext';
class LanguageProvider extends React.Component {
    static getDerivedStateFromProps(props, state) {
        const { lang } = props;
        if (lang != null && lang !== state.lang) {
            return { lang };
        }
        return null;
    }
    constructor(props) {
        super(props);
        this.setLang = (newLang) => {
            const { onChange, lang } = this.props;
            if (lang == null) {
                this.setState({ lang: newLang });
            }
            if (onChange) {
                onChange(newLang);
            }
        };
        this.state = {
            lang: props.lang || 'et',
            setLang: this.setLang,
            isInsideParent: props.isParent,
        };
    }
    render() {
        const { children, isParent } = this.props;
        const isInsideParent = this.context.isInsideParent;
        if (!isParent && isInsideParent) {
            return children;
        }
        return React.createElement(LanguageContext.Provider, { value: { ...this.state }, children: children });
    }
}
LanguageProvider.contextType = LanguageContext;
export default LanguageProvider;
